var _a;
export var setupI18nextLanguage = (_a = require('./i18nConfig'), _a.setupI18nextLanguage), i18n = _a.i18n;
